import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ThumbsDown from './icon-thumbs-down.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ThumbsDown {...validProps} />;
}
SvgComponent.iconName = 'thumbs-down';

/**
 * @deprecated This is a legacy icon
 */
export const ThumbsDownIcon = svgIconWrapper(SvgComponent);
